"use client"

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { ArrowUpDown } from "lucide-react"
import { cn } from "@/lib/utils"

interface SortDropdownProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

const sortOptions = [
  { value: "default", label: "Newest additions" },
  { value: "price-asc", label: "Price: Low to High" },
  { value: "price-desc", label: "Price: High to Low" },
  { value: "popular", label: "Editorial picks first" },
]

export function SortDropdown({ value, onChange, className }: SortDropdownProps) {
  return (
    <div className={cn("flex min-w-0 flex-1 items-center gap-2 sm:flex-none", className)}>
      <span className="text-sm text-gray-600 hidden sm:inline">Sort:</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          aria-label="Sort products"
          className="h-11 w-full min-w-0 text-sm border-gray-200 shadow-xs sm:h-9 sm:w-[180px]"
        >
          <ArrowUpDown className="w-3.5 h-3.5 mr-1.5 text-gray-500 shrink-0" />
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          {sortOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
